export const WELCOME_VIDEO_URL = 'https://www.youtube.com/watch?v=dwnGovqM23E';

// requiredTrainings added a 7th task. Both curves still reach 100% one task early (index N-1);
// the added step is spread across the tail of the curve rather than left as a flat 100/100 plateau.
export const REGULAR_PROGRESS_THRESHOLDS = [ 0, 5, 10, 32, 55, 77, 100 ];
export const MSO_PROVIDER_PROGRESS_THRESHOLDS = [ 0, 0, 5, 10, 55, 78, 100 ]; // matching availability is not required for MSO partners and is auto-approved

// SALESFORCE_CREDENTIALING_ENABLED providers have an extra payorEnrollment task (8 tasks total)
export const SALESFORCE_CREDENTIALING_ENABLED_REGULAR_PROGRESS_THRESHOLDS = [ 0, 5, 10, 30, 50, 70, 85, 100 ];
export const SALESFORCE_CREDENTIALING_ENABLED_MSO_PROGRESS_THRESHOLDS = [ 0, 0, 5, 10, 40, 55, 85, 100 ];
